/* Tab Kim ngạch (board Mint-CustomerDetail, tab 'kn') — số minh hoạ của board, nguồn TblCustomsData theo MST. */
export type KnPeriod = '3M' | '6M' | '1Y' | 'YTD';
export const KN_PERIODS: KnPeriod[] = ['3M', '6M', '1Y', 'YTD'];
export const KN_SRC =
  ' Nguồn: TblCustomsData theo MST khách (Year, Month, ExportDate, Consignee, HSCode, ExportTerm, Customs, ImportCountry, TransportMode, Shipments). Số trên board là minh hoạ.';

const MON = ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'];
const YR = ['2025', '2025', '2025', '2026', '2026', '2026', '2026', '2026', '2026', '2026', '2026', '2026'];
const USD: (number | null)[] = [372, 380, 425, 360, null, 410, 432, 412, 455, 398, 520, 486];
const USD0 = [355, 350, 390, 345, 300, 372, 398, 380, 420, 372, 470, 452];
const DEC = [7, 7, 8, 8, 0, 8, 8, 9, 9, 9, 11, 12];
const DEC0 = [6, 6, 7, 7, 5, 7, 7, 8, 8, 7, 9, 10];
const LOT = [8, 8, 9, 8, 0, 9, 9, 10, 10, 10, 11, 12];
const LOT0 = [7, 7, 8, 7, 5, 8, 8, 8, 9, 8, 10, 10];
const ALL = MON.map((_, i) => i);

/** [tên, mã, cảng, tuyến gợi ý, lô, lô HANA, % kim ngạch, % so cùng kỳ] */
const CT: [string, string, string, string, number, number, number, number][] = [
  ['Hàn Quốc', 'KR', 'Busan · BUS', 'CLI → BUS', 32, 24, 31, 4],
  ['Mỹ', 'US', 'Los Angeles · LAX / LGB', 'CLI → LAX', 20, 13, 22, 9],
  ['Nhật Bản', 'JP', 'Tokyo · TYO · air NRT', 'CLI → TYO', 16, 0, 18, 27],
  ['Hà Lan', 'NL', 'Rotterdam · RTM', 'CLI → RTM', 14, 4, 12, 41],
  ['Úc', 'AU', 'Sydney · SYD', 'CLI → SYD', 10, 0, 8, -6],
  ['Singapore', 'SG', 'Singapore · SIN', 'CLI → SIN', 8, 6, 6, -12],
  ['Đức', 'DE', 'Hamburg · HAM', 'CLI → HAM', 4, 2, 3, -48],
];
const G1: [string, number][] = [['CFR', 22], ['CIF', 18], ['C&F', 12], ['DAP', 4], ['CPT', 0]];
const G2: [string, number][] = [['FOB', 40], ['FCA', 5], ['EXW', 3]];
/** [consignee, nước, lô 12 tháng, HANA đã làm, trạng thái, ghi chú] */
const BUY: [string, string, number, boolean, '' | 'new' | 'stop', string][] = [
  ['Busan Fresh Co.', 'KR', 24, true, '', ''],
  ['Pacific Ocean Foods LLC', 'US', 14, true, '', ''],
  ['Tokai Suisan KK', 'JP', 12, false, '', ''],
  ['Nordhout BV', 'NL', 10, false, 'new', 'Lô đầu 03/2026'],
  ['Lion Home Pte', 'SG', 8, true, '', ''],
  ['Sydney Fresh Pty', 'AU', 6, false, 'new', 'Lô đầu 05/2026'],
  ['Hamburg Seafood GmbH', 'DE', 4, true, 'stop', 'Lô cuối 04/2026 · không có lô 6 tháng gần đây'],
];
const SVT: Record<string, string> = {
  'Kiểm dịch': 'Chứng thư kiểm dịch / an toàn thực phẩm thuỷ sản cho từng lô',
  CO: 'Giấy chứng nhận xuất xứ theo nước đến',
  'Hun trùng': 'Hun trùng pallet gỗ (ISPM 15) khi đóng pallet',
};
const HS: [string, string, number, string[]][] = [
  ['0306', 'Giáp xác (tôm) đông lạnh', 44, ['Kiểm dịch', 'CO']],
  ['0304', 'Cá phi lê đông lạnh', 23, ['Kiểm dịch', 'CO']],
  ['0303', 'Cá nguyên con đông lạnh', 17, ['Kiểm dịch', 'CO', 'Hun trùng']],
  ['0307', 'Nhuyễn thể (mực) đông lạnh', 11, ['Kiểm dịch']],
  ['Khác', '3 mã HS khác', 5, []],
];
const TM: [string, number][] = [['SEA · đường biển', 96], ['AIR · hàng không', 8]];
const CUS: [string, number, number][] = [
  ['HQ CK cảng Sài Gòn KV1 · Cát Lái', 52, 30],
  ['HQ Cà Mau', 22, 0],
  ['HQ CK cảng Cái Mép', 14, 4],
  ['HQ CK sân bay TSN', 8, 2],
];
const ASK: [string, string, string][] = [
  ['Nhật Bản tăng 27% nhưng HANA chưa làm lô nào', '12/16 lô FOB, bên mua Tokai Suisan KK chỉ định forwarder → chào qua đại lý ở Nhật, kèm air SGN → NRT cho hàng tươi.', 'CLI → TYO'],
  ['Úc: khách chọn forwarder, HANA chưa có lô', '8/10 lô CIF / CFR; người mua mới Sydney Fresh Pty từ 05/2026 → Sale chào thẳng CLI → SYD trước mùa cao điểm.', 'CLI → SYD'],
  ['22 tờ khai mở ở HQ Cà Mau, HANA chưa khai thuê', 'Gộp khai thuê tại Cà Mau với trucking Cà Mau → CLI đang chạy; thêm kiểm dịch và CO theo lô.', 'Cà Mau → CLI'],
];
const OPP: [string, string, 'warn' | 'data', string][] = [
  ['Tuyến chưa làm · CLI → TYO', '16 lô', 'warn', 'Nhật Bản · FOB 12/16 lô'],
  ['Tuyến chưa làm · CLI → SYD', '10 lô', 'warn', 'Úc · CIF / CFR 8/10 lô'],
  ['Air SGN → NRT · hàng tươi', '8 lô', 'data', 'TransportMode = AIR'],
  ['Khai thuê HQ Cà Mau', '22 tờ khai', 'data', 'Customs = HQ Cà Mau · HANA 0/22'],
  ['Kiểm dịch + CO theo lô', '95% kim ngạch', 'data', 'Mã HS cần kiểm dịch chiếm 95% kim ngạch'],
];

const f1 = (x: number) => x.toFixed(1).replace('.', ',');
const f2 = (x: number) => x.toFixed(2).replace('.', ',');
const dots = (n: number) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
const sum = (a: number[]) => a.reduce((x, y) => x + y, 0);
export interface Chg { k: string; up: boolean }
export const chg = (a: number, b: number): Chg => {
  const d = b ? (a / b - 1) * 100 : 0;
  const up = d >= 0;
  return { k: `${up ? '▲ +' : '▼ −'}${f1(Math.abs(d))}%`, up };
};

export interface KnData {
  empty: boolean;
  range: string;
  kpi: { k: string; v: string; u: string; chg: Chg; prev: string }[];
  pts: { i: number; m: string; v: number | null; prev: number; tip: string }[];
  peak: [number, number] | null;
  lineAria: string;
  shareK: string;
  share: { k: string; n: string; p: string; w: number; flag: '' | 'Chưa làm' | 'Thấp' }[];
  shareAria: string;
  terms: { k: string; act: string; n: number; p: string; w: number; amber: boolean; items: { k: string; n: number }[] }[];
  termsAria: string;
  ctry: { k: string; port: string; lane: string; lot: string; usd: string; w: number; chg: Chg; sug: boolean }[];
  ctryAria: string;
  buyK: string;
  buyers: { k: string; cc: string; n: number; w: number; hana: boolean; hanaK: string; st: '' | 'Mới' | 'Ngừng'; stTip: string }[];
  hs: { hs: string; k: string; p: string; w: number; svc: { k: string; tip: string }[] }[];
  hsAria: string;
  tmode: { k: string; n: number; p: string; w: number; amber: boolean }[];
  tmodeAria: string;
  etype: { k: string; n: string; tip: string }[];
  cus: { k: string; n: number; h: number; w: number; sug: boolean }[];
  ask: { n: number; k: string; d: string; lane: string }[];
  opp: { k: string; v: string; amber: boolean; tip: string }[];
}

export function knFor(period: KnPeriod, empty: boolean): KnData {
  const ok = (i: number) => USD[i] !== null;
  const sumW = (a: number[], ix: number[]) => sum(ix.filter(ok).map((i) => a[i]!));
  const u = USD.map((v) => v ?? 0);
  const WIN = { '3M': ALL.slice(9), '6M': ALL.slice(6), '1Y': ALL, YTD: ALL.slice(3) }[period];
  const tot = sumW(u, ALL);
  const lotN = sumW(LOT, ALL);
  let pk = 0;
  for (let i = 0; i + 2 < u.length; i++) if (u[i]! + u[i + 1]! + u[i + 2]! > u[pk]! + u[pk + 1]! + u[pk + 2]!) pk = i;
  const wT = sumW(u, WIN), wT0 = sumW(USD0, WIN), wD = sumW(DEC, WIN), wD0 = sumW(DEC0, WIN), wL = sumW(LOT, WIN), wL0 = sumW(LOT0, WIN);
  const hanaN = sum(CT.map((c) => c[5]));
  const g1 = sum(G1.map((x) => x[1])), g2 = sum(G2.map((x) => x[1]));
  const kmx = Math.max(...CT.map((c) => c[6])), bmx = Math.max(...BUY.map((b) => b[2])), hmx = Math.max(...HS.map((h) => h[2]));
  const nNew = BUY.filter((b) => b[4] === 'new').length, nStop = BUY.filter((b) => b[4] === 'stop').length;
  const pkIn = WIN.includes(pk) && WIN.includes(pk + 2);
  const terms: KnData['terms'] = (
    [['Khách chọn forwarder', 'Sale chào trực tiếp', G1, g1, false], ['Bên mua chỉ định', 'Qua đại lý ở nước đến', G2, g2, true]] as const
  ).map(([k, act, items, n, amber]) => ({ k, act, n, p: `${Math.round((n / lotN) * 100)}%`, w: (n / lotN) * 100, amber, items: items.map(([a, b]) => ({ k: a, n: b })) }));
  return {
    empty,
    range: `${MON[WIN[0]!]}/${YR[WIN[0]!]} – Sep/2026`,
    kpi: [
      ['Kim ngạch', f2(wT / 1000), 'tr USD', wT, wT0, `${f2(wT0 / 1000)} tr USD`],
      ['Tờ khai', String(wD), 'tờ khai', wD, wD0, `${wD0} tờ khai`],
      ['Số lô', String(wL), 'lô', wL, wL0, `${wL0} lô`],
    ].map(([k, v, un, a, b, prev]) => ({ k: k as string, v: v as string, u: un as string, chg: chg(a as number, b as number), prev: prev as string })),
    pts: WIN.map((i) => ({
      i,
      m: MON[i]!,
      v: USD[i] ?? null,
      prev: USD0[i]!,
      tip: `${MON[i]}/${YR[i]}: ${USD[i] === null ? 'chưa nạp dữ liệu tờ khai' : `${USD[i]}k USD · cùng kỳ ${USD0[i]}k · ${DEC[i]} tờ khai · ${LOT[i]} lô`}`,
    })),
    peak: pkIn ? [WIN.indexOf(pk), WIN.indexOf(pk + 2)] : null,
    lineAria: `Kim ngạch xuất khẩu theo tháng ${MON[WIN[0]!]}/${YR[WIN[0]!]}–Sep/2026 (nghìn USD): ${WIN.map((i) => `${MON[i]} ${USD[i] ?? 'chưa nạp'}`).join(', ')}. Cùng kỳ năm trước: ${WIN.map((i) => USD0[i]).join(', ')}. Cao điểm ${MON[pk]}–${MON[pk + 2]}.`,
    shareK: `${Math.round((hanaN / lotN) * 100)}%`,
    share: CT.map(([k, , port, , lot, h]) => {
      const p = Math.round((h / lot) * 100), gap = h === 0 && lot >= 8, low = !gap && p < 35;
      return { k: `${k} · ${port.split(' · ')[1]!.split(' ')[0]}`, n: `${h} / ${lot}`, p: `${p}%`, w: p, flag: gap ? 'Chưa làm' : low ? 'Thấp' : '' };
    }),
    shareAria: `Thị phần HANA theo nước đến (lô HANA / tổng lô): ${CT.map((c) => `${c[0]} ${c[5]}/${c[4]}`).join(', ')}. Tổng ${hanaN}/${lotN} lô.`,
    terms,
    termsAria: `Ai nắm cước theo lô: khách chọn forwarder (CIF, CFR, C&F, CPT, DAP) ${g1} lô, bên mua chỉ định (FOB, FCA, EXW) ${g2} lô.`,
    ctry: CT.map(([k, , port, lane, lot, h, p, d]) => ({ k, port, lane, lot: `${lot} lô`, usd: dots(Math.round((tot * p) / 100)), w: Math.round((p / kmx) * 100), chg: chg(100 + d, 100), sug: h / lot < 0.35 })),
    ctryAria: `Top nước đến theo kim ngạch (nghìn USD): ${CT.map((c) => `${c[0]} ${Math.round((tot * c[6]) / 100)}`).join(', ')}.`,
    buyK: `${nNew} mới · ${nStop} ngừng · lô 12 tháng`,
    buyers: BUY.map(([k, cc, n, hana, st, tip]) => ({ k, cc, n, w: Math.round((n / bmx) * 100), hana, hanaK: hana ? 'HANA đã làm hàng' : 'HANA chưa làm', st: st === 'new' ? 'Mới' : st === 'stop' ? 'Ngừng' : '', stTip: tip })),
    hs: HS.map(([hs, k, p, svc]) => ({ hs, k, p: `${p}%`, w: Math.round((p / hmx) * 100), svc: svc.map((x) => ({ k: x, tip: SVT[x] ?? x })) })),
    hsAria: `Tỷ trọng kim ngạch theo mã HS: ${HS.map((h) => `${h[0]} ${h[2]}%`).join(', ')}.`,
    tmode: TM.map(([k, n], i) => ({ k, n, p: `${Math.round((n / lotN) * 100)}%`, w: (n / lotN) * 100, amber: i > 0 })),
    tmodeAria: `Phương thức vận tải theo lô: ${TM.map((x) => `${x[0]} ${x[1]}`).join(', ')}.`,
    etype: [{ k: 'Xuất kinh doanh', n: '92', tip: 'ExportType' }, { k: 'Xuất SP SXXK', n: '4', tip: 'ExportType' }],
    cus: CUS.map(([k, n, h]) => ({ k, n, h, w: Math.round((h / n) * 100), sug: n >= 10 && h / n < 0.35 })),
    ask: ASK.map(([k, d, lane], i) => ({ n: i + 1, k, d, lane })),
    opp: OPP.map(([k, v, c, tip]) => ({ k, v, amber: c === 'warn', tip })),
  };
}
